import { SetPersonalNumberCommand } from "../../personal-number/model/set-personal-number-command";

export namespace UserStateActions {
    export class GetUser {
        public static readonly type = "[User] GetUser";
    }

    export class GetAgreement {
        public static readonly type = "[User] GetUserAccountAgreement";
    }

    export class GetAgreementLatestPublishedVersionNumber {
        public static readonly type = "[User] GetAgreementLatestPublishedVersionNumber";
    }

    export class SetPersonalNumber {
        public static readonly type = "[User] SetPassword";
        constructor(public command: SetPersonalNumberCommand) {}
    }

    export class TestPushNotification {
        public static readonly type = "[User] TestPushNotification";
    }
}
